import { useNavigate, useParams } from '@tanstack/react-router';
import { CUSTOMER_DATA_TABS } from 'cpool-constants';

import { HeaderActions } from './HeaderActions';
import Employment from '~/features/leadDetails/components/Overview/CustomerData/Employment';
import IncomeAndExpenses from '~/features/leadDetails/components/Overview/CustomerData/IncomeAndExpenses';
import LivingSituation from '~/features/leadDetails/components/Overview/CustomerData/LivingSituation';
import PersonalData from '~/features/leadDetails/components/Overview/CustomerData/PersonalData';
import RealEstates from '~/features/leadDetails/components/Overview/CustomerData/RealEstates';
import { Tabs } from '~/features/leadDetails/components/Overview/CustomerData/Tabs.tsx';
import { CUSTOMER_DATA_TAB_PATHS } from '~/features/leadDetails/constants/tabPaths';
import CustomerDataTabsContextProvider from '~/features/leadDetails/context/CustomerDataTabsContext.tsx';
import useLead from '~/features/leadDetails/hooks/useLead.ts';
import { getCustomerDataTabFromPath } from '~/features/leadDetails/utils/tabPaths';

export const CustomerData = () => {
    const { customerTab, leadId } = useParams({ strict: false });
    const { data: lead } = useLead(leadId);
    const navigate = useNavigate();
    const customerDataTab = getCustomerDataTabFromPath(customerTab ?? '') ?? CUSTOMER_DATA_TABS.PERSONAL_DATA;

    if (!lead) return null;

    return (
        <CustomerDataTabsContextProvider
            selectedTab={customerDataTab}
            onTabChange={(tab) =>
                navigate({
                    params: { customerTab: CUSTOMER_DATA_TAB_PATHS[tab], leadId: lead.id },
                    search: (previous) => previous,
                    to: '/leads/details/$leadId/customer-data/$customerTab',
                })
            }
        >
            <div className="flex w-full items-center justify-end py-2">
                <HeaderActions lead={lead} />
            </div>
            <Tabs />
            <div className="flex flex-row w-full">
                <div className="w-full">
                    <PersonalData lead={lead} />
                    <IncomeAndExpenses lead={lead} />
                    <LivingSituation lead={lead} />
                    <RealEstates lead={lead} />
                    <Employment lead={lead} />
                </div>
            </div>
        </CustomerDataTabsContextProvider>
    );
};
